import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const PortalContext = createContext(null);
export const usePortal = () => useContext(PortalContext);

export const PortalProvider = ({ children }) => {
  const { user } = useAuth();
  const canManage = user?.role === "admin" || user?.role === "power_user";
  const canSelectClient = canManage || ["legal_rep", "accountant", "broker", "caretaker"].includes(user?.role);
  const [clients, setClients] = useState([]);
  const [selectedClientId, setSelectedClientId] = useState(() => localStorage.getItem("va_selected_client") || "");

  useEffect(() => {
    if (canSelectClient) api.get("/users/clients").then((r) => setClients(r.data)).catch(() => {});
  }, [canSelectClient]);

  const choose = (id) => {
    setSelectedClientId(id);
    if (id) localStorage.setItem("va_selected_client", id);
    else localStorage.removeItem("va_selected_client");
  };

  return (
    <PortalContext.Provider value={{ clients, selectedClientId, setSelectedClientId: choose, canManage, canSelectClient }}>
      {children}
    </PortalContext.Provider>
  );
};
